/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/CancelOrderItems.Forms',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    var CancelOrderItemsForms = {
        RmaForm: {
            Fields: [
                {
                    "Name": 'Name',
                    "Field": '#rma_first_name',
                    "Param": 'firstName',
                    "Type": 'Text',
                    "Optional": false
                },
                {
                    "Name": 'Email',
                    "Field": '#rma_email',
                    "Param": 'email',
                    "Optional": false,
                    "Type": 'Text',
                    "Validators": [
                        {
                            "Type": 'Email'
                        }
                    ]
                },
                {
                    "Name": 'Po Number',
                    "Field": '#rma_po_number',
                    "Param": 'poNumber',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Replacement reason',
                    "Field": '#rma_replacement_reason',
                    "Param": 'reason',
                    "Type": 'Text',
                    "Optional": false
                },
                {
                    "Name": 'Your Branch',
                    "Field": '#rma_branch',
                    "Param": 'branch',
                    "Type": 'Text',
                    "Optional": true
                },                
                {
                    "Name": 'Issue replacement',
                    "Field": '#rma_issue_replacement',
                    "Param": 'issueReplacement',
                    "Type": 'Checkbox',
                    "Optional": true
                },
                {
                    "Name": 'Is original packaging',
                    "Field": '#rma_is_orig_packaging',
                    "Param": 'isOriginalPackaging',
                    "Type": 'Checkbox',
                    "Optional": true
                },
                {
                    "Name": 'Additional Info',
                    "Field": '#rma_additional_info',
                    "Param": 'additionalInfo',
                    "Type": 'Text',
                    "Optional": false
                },
                {
                    "Name": 'Contact way',
                    "Field": '#rma_contact_way',
                    "Param": 'contactWay',
                    "Type": 'Text',
                    "Optional": false
                },
                {
                    "Name": 'Form Document',
                    "Field": '#rma_upload_picture',
                    "Param": 'uploadedFile',
                    "Type": 'File',
                    "Optional": true
                }
            
            ],
            Validate: true
        }
    };

    Roc.Logger.debug('CancelOrderItems.Forms.js Loaded:', CancelOrderItemsForms);

    return CancelOrderItemsForms;
});
